import { ServerConfig } from "@/config/config";
import { Axios } from "./auth-service";
import {CompanyStatsFilter} from "@/utils/company-stats-filter";

export interface IInstallationsResult {
	newStarters:number[]
	newProfs:number[]
	newEnts:number[]
	newAll:number[]
	totalStarter:number[]
	totalProf:number[]
	totalEnt:number[]
	totalAll:number[]
	diffStarter:number[]
	diffProf:number[]
	diffEnt:number[]
	diffAll:number[]
}

interface IInstallationsRecord {
	WeekNumber:number;
	Count:number;
}

interface IInstallationsResponseTier {
	NewRecords:IInstallationsRecord[]
	ExpiredRecords:IInstallationsRecord[]
	StartValue:number;
}

interface IInstallationsResponse {
	starter:IInstallationsResponseTier
	prof:IInstallationsResponseTier
	ent:IInstallationsResponseTier
}

export interface ISalesBetweenDates {
	tier1:string;
	tier2:string;
	tier3:string;
}
export interface ISalesBetweenWrapper {
	Left:ISalesBetweenDates;
	Right:ISalesBetweenDates;
}

function createList(tier:IInstallationsResponseTier, weekCount:number):number[]{
	let result = "0".repeat(weekCount).split("").map(i=>0);
	tier.NewRecords.forEach((val, i)=>{
		result[val.WeekNumber-1] += val.Count;
	});
	tier.ExpiredRecords.forEach((val, i)=>{
		result[val.WeekNumber-1] -= val.Count;
	});
	let total = tier.StartValue;
	for (let i in result) {
		result[i] = total + result[i];
		total = result[i];
	}
	return result;
}
function createNewList(tier:IInstallationsResponseTier, weekCount:number):number[] {
	let result = "0".repeat(weekCount).split("").map(i=>0);
	tier.NewRecords.forEach((val, i)=>{
		result[val.WeekNumber-1] += val.Count;
	});
	return result;
}
function createDiffList(tier:IInstallationsResponseTier, weekCount:number):number[]{
	let result = "0".repeat(weekCount).split("").map(i=>0);
	tier.NewRecords.forEach((val, i)=>{
		result[val.WeekNumber-1] += val.Count;
	});
	tier.ExpiredRecords.forEach((val, i)=>{
		result[val.WeekNumber-1] -= val.Count;
	});
	let total = 0;
	for (let i in result) {
		result[i] = total + result[i];
		total = result[i];
	}
	return result;
}

export class StatisticsServiceClass {

	private readonly url:string = `${ServerConfig.host}/admin/statistics`;
	private readonly demoUrl:string = `${this.url}/demos`
	private readonly companyUrl:string = `${this.url}/companies`
	private readonly salesUrl:string = `${this.url}/sales`


	public async getCompanyResults(filter:Array<any>):Promise<number[]>{
		console.log(filter);
		let q = Object.keys(filter).map(key => key + "=" + filter[<any>key]).join("&");
		console.log(q);
		let result = await Axios.get(`${this.companyUrl}/?`+q);
		return result.data;
	}

	public async getSalesResults(filter1:CompanyStatsFilter,filter2:CompanyStatsFilter):Promise<ISalesBetweenWrapper> {
		let result = await Axios.post(`${this.salesUrl}/`, {
			Year1: filter1.year.toString(),
			Year2: filter2.year.toString(),
			Month1: filter1.mode.toString(),
			Month2: filter2.mode.toString(),
		});

		return result.data;
	}

	public async getInstallations(startDate:Date, endDate:Date, onlyShowCreatedByWfOnline:boolean):Promise<IInstallationsResult>{
		let response = await Axios.get(`${this.companyUrl}/installations`, {params: {
			startDate: `${startDate.getFullYear()}-${startDate.getMonth()+1}-${startDate.getDate()}`,
			endDate: `${endDate.getFullYear()}-${endDate.getMonth()+1}-${endDate.getDate()}`,
			onlyCreatedByWfOnline: `${onlyShowCreatedByWfOnline}`
		}});
		let items = (response.data as IInstallationsResponse);
		let weekCount = Math.ceil((endDate.getTime() - startDate.getTime()) / (3600000*24*7));

		let result:IInstallationsResult = {
			newStarters: createNewList(items.starter, weekCount),
			newProfs: createNewList(items.prof, weekCount),
			newEnts: createNewList(items.ent, weekCount),
			newAll: [],
			totalStarter: createList(items.starter, weekCount),
			totalProf: createList(items.prof, weekCount),
			totalEnt: createList(items.ent, weekCount),
			totalAll: [],
			diffStarter: createDiffList(items.starter, weekCount),
			diffProf: createDiffList(items.prof, weekCount),
			diffEnt: createDiffList(items.ent, weekCount),
			diffAll: []
		};

		result.newAll = result.newStarters.map((item,i)=>item+result.newProfs[i]+result.newEnts[i]);
		result.totalAll = result.totalStarter.map((item,i)=>item+result.totalProf[i]+result.totalEnt[i]);
		result.diffAll = result.diffStarter.map((item,i)=>item+result.diffProf[i]+result.diffEnt[i]);

		return result;
	}

	public async getNewDemosLastWeek():Promise<number[]>{
		let result = await Axios.get(`${this.demoUrl}/last-week`);
		return result.data;
	}

	public async getNewDemosLastMonth():Promise<number[]>{
		let result = await Axios.get(`${this.demoUrl}/last-month`);
		return result.data;
	}

	public async getNewDemosLastHalfYear():Promise<number[]>{
		let result = await Axios.get(`${this.demoUrl}/last-half-year`);
		return result.data;
	}

	public async getNewDemosLastYear():Promise<number[]>{
		let result = await Axios.get(`${this.demoUrl}/last-year`);
		return result.data;
	}
}

export const StatisticsService = new StatisticsServiceClass();